import { render, staticRenderFns } from "./send-comment.vue?vue&type=template&id=65d800fa"
import script from "./send-comment.vue?vue&type=script&lang=js"
export * from "./send-comment.vue?vue&type=script&lang=js"
import style0 from "./send-comment.vue?vue&type=style&index=0&id=65d800fa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports